var _ = require('underscore');
var TorsoFormView = require('backbone-torso/modules/FormView');
var payableEstimatesItemTemplate = require('./payableEstimatesItemTemplate.hbs');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');
var billingConfigModel = require('./../financial/billingConfigModel');
var inputUtils = require('./../utils/inputUtils');

/**
 * Form view for Make Payment Payable Estimates Item
 *
 * @class PayableEstimatesItemView
 */
module.exports = TorsoFormView.extend({
  tagName: 'li',
  className: 'brec-list__item brec-list__item--border portal-list__item--payable-item',
  attributes: {
    'data-test-list-item': 'estimation'
  },
  template: payableEstimatesItemTemplate,

  behaviors: {
    useModalBehavior: {
      behavior: UseModalBehavior
    }
  },

  prepareFields: {
    estimateModel: '_estimateModel',
    billPaymentDetail: function() {
      var identifier = this._estimateModel.getIdentifier();
      return this.model.get('billPaymentDetails.' + identifier);
    },
    noRemainingBalance: function() {
      var remainingBalance = this._estimateModel.get('remainingBalance');
      return remainingBalance <= 0;
    },
    identifier: function() {
      return this._estimateModel.getIdentifier();
    },
  },

  events: {
    'keypress [data-payment-amount-field]': function(event) {
      inputUtils.sanitizeAmount(event);
    },
    'click [data-pay-full-btn]': '_payFull',
    'click [data-pay-none-btn]': '_payNone'
  },

  /**
   * Configures feedback bindings.
   * @property feedback {Array of When/Then Feedbacks}
   */
  feedback: [
    /**
     * When someone blurs from the partial payment amount input field,
     * Then we format the amount to currency.
     * @property feedback[0] (Payment Amount Input Field Formatting) {When/Then Feedback}
     */
    {
      when: {
        '@billPaymentDetails[identifier].amount' : ['blur']
      },
      then: function(event, indexMap) {
        this.model.formatAmount(indexMap.identifier);
        var result = this.model.get('billPaymentDetails[' + indexMap.identifier + '].amount');
        return { val: result };
      },
      to: 'billPaymentDetails[identifier].amount'
    },
    /**
     * When someone blurs from the partial payment amount input field,
     * Then we verify the amount entered is not greater than the amount due.
     * If it is, it will highlight the input field.
     * @property feedback[1] (Payment Amount Input Field Styling) {When/Then Feedback}
     */
    {
      when: {
        '@billPaymentDetails[identifier].amount' : ['keyup', 'blur'],
        'listenTo': [
          {
            object: 'model',
            events: 'change:billPaymentDetails'
          }
        ]
      },
      then: function(event, indexMap) {
        var errorMessage = this._validateInput(indexMap);
        return errorMessage.error ? { addClass: 'brec-form__input--error' } : { removeClass: 'brec-form__input--error' };
      },
      to: 'billPaymentDetails[identifier].amount'
    },
    /**
     * When someone blurs from the partial payment amount input field,
     * Then we verify the amount entered is not greater than the amount due.
     * If it is, it will show the error container.
     * @property feedback[2] (Payment Amount Error Styling) {When/Then Feedback}
     */
    {
      when: {
        '@billPaymentDetails[identifier].amount' : ['keyup', 'blur'],
        'listenTo': [
          {
            object: 'model',
            events: 'change:billPaymentDetails'
          }
        ]
      },
      then: function(event, indexMap) {
        var errorMessage = this._validateInput(indexMap);
        if (errorMessage.error) {
          return {
            removeClass: 'brec-hidden',
            attr: ['aria-hidden', 'false']
          };
        } else {
          return {
            addClass: 'brec-hidden',
            attr: ['aria-hidden', 'true']
          };
        }
      },
      to: 'paymentAmountError[identifier]'
    },
    /**
     * When someone blurs from the partial payment amount input field,
     * Then we verify the amount entered is greater than zero.
     * If it's not, it will show the error message.
     * @property feedback[3] (Payment Amount Error Message) {When/Then Feedback}
     */
    {
      when: {
        '@billPaymentDetails[identifier].amount' : ['keyup', 'blur'],
        'listenTo': [
          {
            object: 'model',
            events: 'change:billPaymentDetails'
          }
        ]
      },
      then: function() {
        var errors = this.model.preValidate(['billPaymentDetails']);
        if (_.isEmpty(errors)) {
          return { text: ''};
        } else {
          return { text: this.format('payment.payableBillsItem.error.overpay') };
        }
      },
      to: 'paymentAmountErrorMsg[identifier]'
    }
  ],

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.estimateModel {InsuranceEstimationModel} the model containing the insurance estimation for this item.
   *   @param options.context {Object} the item context from the list view parent.
   *     @param options.context.paymentDetailsFormModel {PaymentDetailsFormModel} the form model to use.
   * @override
   */
  initialize: function(options) {
    this._estimateModel = options.estimateModel;
    this.model = options.context.paymentDetailsFormModel;
    var identifier = this._estimateModel.getIdentifier();
    this.listenTo(this.model, 'change:billPaymentDetails.' + identifier + '.paid billPaid', this.render);
    this.set('payPartial', false);
    this.listenTo(this.viewState, 'change:payPartial', this.render);
    billingConfigModel.loadOnce();
  },

  /**
   * Validate the amount input field and return the error associated with the input field.
   * @param indexMap {Object} the indexMap of the input field
   * @method _validateInput
   * @private
   */
  _validateInput: function(indexMap) {
    var errors = this.model.preValidate(['billPaymentDetails']) || {};
    var errorMessages = errors.billPaymentDetails;
    var identifier = indexMap.identifier;
    return _.findWhere(errorMessages, {paymentIdentifier: identifier}) || {};
  },

  /**
   * Set payment amount to amount due.
   * @method _payFull
   * @private
   */
  _payFull: function() {
    this.model.payFullEstimate(this._estimateModel);
  },

  /**
   * Set payment amount to 0.
   * @method _payNone
   * @private
   */
  _payNone: function() {
    this.model.payNoneEstimate(this._estimateModel);
  }
});
